































import { Component, Mixins } from 'vue-property-decorator'
import SalesOrgTab from './SalesOrgTab.vue'
import SalesOrgDialog from './SalesOrgDialog.vue'
import ConfirmDeleteDialog from '@/components/Dialogs/ConfirmDialog.vue'
import { SalesOrgDto } from '@/services/connecteur'
import SalesOrgsModule from '@/store/modules/SalesOrgsModule'
import BaseVue from '@/mixins/BaseVue'

@Component({
  components: {
    SalesOrgTab,
    SalesOrgDialog,
    ConfirmDeleteDialog
  }
})
export default class SalesOrgPage extends Mixins(BaseVue) {
  public search = ''
  public openDialog = false
  public opendConfirDeleteDialog =false
  public displayDisabled = false

  public get selectedSalesOrg(): SalesOrgDto {
    return SalesOrgsModule.selectedSalesOrg
  }

  public async reactivateSalesOrg() {
    try {
      await SalesOrgsModule.reactivateSalesOrg(this.selectedSalesOrg)
      this.displayMessage(this.$t('salesOrg.reactivated'))
    } catch (error) {
      this.displayError(error)
    }
  }

  public async deleteSalesOrg() {
    try {
      await SalesOrgsModule.deleteSalesOrg(this.selectedSalesOrg)
      this.displayMessage(this.$t('salesOrg.deleted'))
    } catch (error) {
      this.displayError(error)
    }

    this.opendConfirDeleteDialog = false
  }
}
